import { useState, useEffect } from "react";
import {
  Activity,
  ChevronDown,
  ChevronUp,
  Group,
  Home,
  Inbox,
  PlusIcon,
  ShoppingBag,
  User,
  User2,
  Users,
  HandCoins,
  Church,
  Megaphone,
  UserPlus,
  UsersRound,
  Banknote,
  Cross,
  ListChecks,
  BellRing
} from "lucide-react";
import dataEn from "../dataEn";
import dataKin from "../dataKin";
import { language } from "../tools/language";
const data = language === "en" ? dataEn : dataKin;

function SideBar({ onMenuClick }) {
  const [isDashboardSubMenuOpen, setIsDashboardSubMenuOpen] = useState(false);
  const [isEcommerceSubMenuOpen, setIsEcommerceSubMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState("");
  const [userPosition, setUserPosition] = useState("");

  // Get user position from localStorage on component mount
  useEffect(() => {
    const position = localStorage.getItem("position");
    if (position) {
      setUserPosition(position);
    }
  }, []);

  const toggleDashboardSubMenu = () => {
    setIsDashboardSubMenuOpen(!isDashboardSubMenuOpen);
  };

  const toggleEcommerceSubMenu = () => {
    setIsEcommerceSubMenuOpen(!isEcommerceSubMenuOpen);
  };

  const handleMenuClick = (menuKey) => {
    setActiveMenu(menuKey);
    onMenuClick(menuKey);
  };

  // Base menu items that all users can see
  const baseMenuItems1 = [
    { key: "allChristian", icon: <Users />, title: data.menu.allChristian },
    { key: "allChildren", icon: <Users />, title: data.menu.allChildren },
    { key: "viewReport", icon: <Inbox />, title: data.menu.report },
  ];

  // Menu items that only admin/administrator can see
  const adminMenuItems = [
    { key: "addChristian", icon: <UserPlus />, title: data.menu.addChristian },
    // Add other admin-only menu items here
  ];

  // Combine menu items based on user position
  const menuItems1 = userPosition === "staff" 
    ? baseMenuItems1 
    : [...baseMenuItems1, ...adminMenuItems];

  const menuItems2 = [
    { key: "announcement", icon: <BellRing />, title: data.menu.announcement },
  ];

  // Open immediately submenu of sidebar when mounted
  useEffect(() => {
    const activeMenu = 'dashboard';
    if (activeMenu === 'dashboard') {
      toggleDashboardSubMenu();
    }
  }, []);

  return (
    <div className="flex overflow-hidden">
      <nav className="side-nav">
        <ul>
          <li>
            <a
              href="./"
              onClick={() => handleMenuClick("home")}
              className="bg-[#F1F5F9] side-menu side-menu--active"
              style={{
                backgroundColor: !activeMenu || activeMenu === "home" || activeMenu === "dashboard" ? "#adc1cb" : "#F1F5F9",
                color: activeMenu === "dashboard" ? "white" : "inherit",
              }}
            >
              <div className="side-menu__icon">
                <Home />
              </div>
              <div className="side-menu__title text-white">Dashboard</div>
            </a>

            <a
              href="#"
              className="bg-[#F1F5F9] side-menu side-menu--active"
              onClick={toggleDashboardSubMenu} 
              style={{
                backgroundColor: activeMenu === "dashboard" ? "#164E63" : "#F1F5F9",
                color: activeMenu === "dashboard" ? "white" : "inherit",
              }}
            >
              <div className="side-menu__icon">
                <Home />
              </div>
              <div className="side-menu__title">
                {data.names.firstName} {data.names.lastName}
                <div className="side-menu__sub-icon transform rotate-180">
                  {isDashboardSubMenuOpen ? (
                    <ChevronDown className="menu__sub-icon" />
                  ) : (
                    <ChevronUp className="menu__sub-icon" />
                  )}
                </div>
              </div>
            </a>
            <ul
              className={
                isDashboardSubMenuOpen
                  ? "side-menu__sub-open"
                  : "side-menu__sub-closed"
              }
            >
              {menuItems1.map((item) => (
                <li key={item.key}>
                  <a
                    href="#"
                    onClick={() => handleMenuClick(item.key)}
                    className="side-menu"
                    style={{
                      backgroundColor: activeMenu === item.key ? "#164E63" : "",
                      color: activeMenu === item.key ? "white" : "",
                    }}
                  >
                    <div className="side-menu__icon">{item.icon}</div>
                    <div className="side-menu__title">{item.title}</div>
                  </a>
                </li>
              ))}
            </ul>
          </li>
          {menuItems2.map((item) => (
            <li key={item.key}>
              <a
                href="#"
                onClick={() => handleMenuClick(item.key)}
                className="bg-[#F1F5F9] side-menu"
                style={{
                  backgroundColor: activeMenu === item.key ? "#164E63" : "#F1F5F9",
                  color: activeMenu === item.key ? "white" : "inherit",
                }}
              >
                <div className="side-menu__icon">{item.icon}</div>
                <div className="side-menu__title">{item.title}</div>
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}

export default SideBar;